__turbopack_context__.v({
  "className": "ELTdiq_className",
  "variable": "ELTdiq_variable",
});
